export default __webpack_public_path__ + "static/media/wife-and-cat.d946801b.webp";